import { ChangeDetectionStrategy, Component, ElementRef, input, output, viewChildren } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { FlightSummaryItem } from './flight-summary.interface';

@Component({
  selector: 'fcom-flight-summary',
  templateUrl: './flight-summary.component.html',
  styleUrls: ['./flight-summary.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlightSummaryComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  items = input.required<FlightSummaryItem[]>();

  clicked = output<number>();

  private readonly rowButtons = viewChildren<ElementRef<HTMLButtonElement>>('rowButton');

  focusRow(index: number): void {
    this.rowButtons()?.[index]?.nativeElement?.focus();
  }
}
